import ExternalSourceLink from './ExternalSourceLink'

export default ExternalSourceLink
